import deepmerge from 'deepmerge'

const MIN_DATE = '1900-01-01'
const MAX_DATE = '4000-12-31'

/**
 * ユーザ情報
 */
export const init = {
  // 現在のユーザの組織コード
  orgcode: '',

  id: 0,
  name: '',
  birthday: MIN_DATE,
  licenseAcquire: MIN_DATE,
  licenseExpire: MAX_DATE,
  licenseAT: 0,
  services: {
    repeater: 0,
    keykey: 0
  }
}

export default deepmerge(init, {})
